import React from 'react'

export default function Noticias () {
	return (
		<div>ola</div>
	)
}